const tvDetailedRateCard = {
  key: "tv",
  title: "TV Detailed Rate Card",
  note:
    "Indicative TV pricing. Panel, motherboard, and display faults require diagnosis first and may have wide price variation.",
  sections: [
    {
      title: "Inspection",
      items: [
        { name: "TV inspection", price: "₹249 visit" },
      ],
    },
    {
      title: "Installation",
      items: [
        { name: "TV wall mount installation", price: "₹599 onwards" },
        { name: "TV uninstallation", price: "₹349" },
      ],
    },
    {
      title: "Repair Support",
      items: [
        { name: "Sound / speaker issue support", price: "₹349 onwards" },
        { name: "Power / startup support", price: "₹349 onwards" },
      ],
    },
  ],
};

export default tvDetailedRateCard;